var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-form-item',[_vm._l((_vm.todos),function(todoObj){return _c('Items',{key:todoObj.id,attrs:{"todoObj":todoObj}})}),(!_vm.hasTodo)?_c('h2',[_vm._v("暂无项目")]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }